import classNames from "classnames";
import React from "react";
import LoaderShape from "../../assets/loader_shape.paths.svg";
import styles from "./closerLoader.css";

interface Props {
  width?: string;
  height?: string;
  signupStyle?: boolean;
  backgroundColor?: string;
  iconColor?: string;
}

export const CloserLoaderComponent: React.SFC<Props> = ({
  width,
  height,
  backgroundColor,
  iconColor,
  signupStyle
}) => (
  <div
    className={classNames(styles.loader, { [styles.signup]: signupStyle })}
    style={{ width, height, color: backgroundColor, backgroundColor: iconColor }}
    dangerouslySetInnerHTML={{ __html: LoaderShape }}
  />
);
